@if (breadcrumb().length) {
  <ui-breadcrumb [nodes]="breadcrumb()" [title]="title()"></ui-breadcrumb>
}

@let _current = current();
@let _error = error();

<div class="page-content">
  @if (shouldUsePathBasedContentRoute()) {
    <ui-content-page-route></ui-content-page-route>
  } @else {
    @switch (_current?.type) {
      @case ('category') {
        <ui-catalog-search-route
          q=""
          category="{{ current()?.id }}"
          page="{{ page() ?? 0 }}"
          [ipp]="ipp()"
          [sort]="sort()"
          [label]="label()"
          [manufacturer]="manufacturer()"
          [own_brand]="own_brand()"
          [isCategoryRoute]="true"
        ></ui-catalog-search-route>
      }
      @case ('content') {
        <ui-content-page-route></ui-content-page-route>
      }
      @default {
        <router-outlet></router-outlet>
      }
    }
  }

  @if (_error) {
    <ui-maintenance></ui-maintenance>
  }

</div>
